import { Currency, Language } from '#root/store/types';
import { useLanguage } from './use-language';

const languageToCurrencyMap: { [key in Language | 'default']: Currency } = {
  da: 'dkk',
  en: 'eur',
  de: 'eur',
  default: 'dkk',
};

export const useDefaultCurrency = () => {
  const language = useLanguage();

  return (
    languageToCurrencyMap[language as keyof typeof languageToCurrencyMap] ??
    languageToCurrencyMap.default
  );
};
